import { styled } from '@mui/system';

import { Outlet } from 'react-router';

import { MainHeader } from './components/MainHeader';

const StyledMain = styled('div')({
  flex: 1,
  overflow: 'auto',
});

const StyledContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(5),
}));

export const Main = () => {
  return (
    <StyledMain>
      <MainHeader />
      <StyledContent>
        <Outlet />
      </StyledContent>
    </StyledMain>
  );
};
